import { useState, useEffect } from 'react';

function TimeoutComponent({
  show,
  hide,
  ms,
}: {
  show: any;
  hide: any;
  ms: number;
}) {
  const [shouldShow, setShouldShow] = useState(ms !== 0);

  // On componentDidMount set the timer
  useEffect(() => {
    setShouldShow(ms !== 0);
    const timeId =
      ms !== 0
        ? setTimeout(() => {
            setShouldShow(false);
            console.log('timeout');
          }, ms)
        : undefined;

    return () => {
      clearTimeout(timeId);
    };
  }, [ms]);

  if (shouldShow) {
    return show;
  }
  return hide;
}

export default TimeoutComponent;
